import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Button, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { RecordManagementAddButtonProps as Props } from './types';

export const RecordManagementAddButton = memo(
  ({ className, icon, value, onClick, disabled }: Props) => {
    return (
      <Button
        className={classnames('RecordManagementAddButton', className)}
        sx={SX.root}
        onClick={onClick}
        variant="outlined"
        size="small"
        startIcon={icon && <Icon name={icon} color="grey.600" />}
        endIcon={!value && <Icon name="plus" color="grey.500" />}
        disabled={disabled}
      >
        {!!value && (
          <Stack sx={SX.valueWrapper}>
            <Typography variant="body5" fontWeight={400} color="success.800">
              {value}
            </Typography>
          </Stack>
        )}
      </Button>
    );
  }
);

RecordManagementAddButton.displayName = 'RecordManagementAddButton';
